import React from "react";
import { Card } from "antd";
import { BsPencil, BsFillTrash3Fill } from "react-icons/bs";
import { Delete } from "../../../functions/surveyTemplate";
import { DeleteGenericTemplate } from "../../../functions/genericTemplate";
import { loaderReducer } from "../../../components/toolkit/loader";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import Cookies from "universal-cookie";

const Index = ({ arg: {genericTemplateListData, genericTemplateFetchData, listData, openEditModel, openEditGenericTemplateModel, fetchData, showButton}}) => {
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const token = cookies.get("token");

  const onClickDelete = async (id) => {
    
    try {
      const confirmed = await withReactContent(Swal).fire({
        title: "Are you sure?",
        text: "Are you sure you want to delete this item?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
      
      if (confirmed.isConfirmed) {
        dispatch(loaderReducer(true));
        await Delete(id, token)
          .then((res) => {
            dispatch(loaderReducer(false));
            toast.success(`${res.data.message}`);
            fetchData();
          })
          .catch((err) => {
            dispatch(loaderReducer(false));
            toast.error(err.message);
            console.error(err);
          });
      } else {
        dispatch(loaderReducer(false));
      }
    } catch (error) {
      dispatch(loaderReducer(false));
      toast.error(error || "Getting some issue, try again.");
    }
  };
  
  const onClickGenericTemplateDelete = async (id) => {
    try {

      const confirmed = await withReactContent(Swal).fire({
        title: "Are you sure?",
        text: "Are you sure you want to delete this item?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });


      if (confirmed.isConfirmed) {
        dispatch(loaderReducer(true));
        await DeleteGenericTemplate(id, token)
        .then((res) => {
          dispatch(loaderReducer(false));
          toast.success(`${res.data.message}`);
          genericTemplateFetchData();
        })
        .catch((err) => {
          dispatch(loaderReducer(false));
          toast.error(err.message);
          console.log(err);
        });
      } else {
        dispatch(loaderReducer(false));
      }
    } catch (error) {
      dispatch(loaderReducer(false));
      toast.error(error || "Getting some issue, try again.");
    }
  };

  return (
    <div>
      <div className="mt-5">
      {listData.map((value, index) => (
        <Card
          hoverable
          style={{ marginTop: "1rem" }}
          key={index}
        >
          <div className="position-relative">
            <div
              className="surveytemp"
              style={{ backgroundColor: "rgba(138, 198, 64, 0.5)" }}
            >
              Survey Template
            </div>
            <div className="sub2head mt-2">[{value.title}]</div>
            <div className="sub2head mt-1">[{value.jobType}]</div>
            <div style={{ paddingRight: "1rem" }} className="mt-1">
              Survey Template
            </div>
            {/* <img src="/images/arrow.png" alt="" className="arrowCls" /> */}
            {showButton && <> 
              <BsPencil className="icon_dis_1" onClick={() => openEditModel(value)} />
              <BsFillTrash3Fill className="icon_dis_2" onClick={() => onClickDelete(value._id)} />
              </>
            }
          </div>
        </Card>
      ))}

      {genericTemplateListData && genericTemplateListData.map((value, index) => (   
        <Card
          hoverable
          style={{ marginTop: "1rem" }}
          key={index}
        >
          <div className="position-relative">
            <div
              className="surveytemp"
              style={{
                backgroundColor: "rgba(28, 68, 156, 0.30)",
              }}
            >
              Questionnaire Template
            </div>
            <div className="sub2head mt-2">[{value.title}]</div>
            <div className="sub2head mt-1">[{value.jobType}]</div>
            <div style={{ paddingRight: "1rem" }} className="mt-1">
            Questionnaire Template
            </div>
             {showButton && <> 
              <BsPencil className="icon_dis_1" onClick={() => openEditGenericTemplateModel(value)} />
              <BsFillTrash3Fill className="icon_dis_2" onClick={() => onClickGenericTemplateDelete(value._id)} />
             </>
            }
          </div>
        </Card>
      ))}
      </div>
    </div>
  );
};

export default Index;
